export const BRAND = {
  name: "Your Surface My Purpose",
  tagline: "Clean Surfaces. Better Health. Brighter Spaces.",
  phone: "804-729-1955",
  phoneRaw: "8047291955",
  email: "ysmpllc@gmail.com",
};

export const VIDEOS = [
  {
    id: "hero",
    title: "High-Pressure Surface Restoration",
    description: "Watch years of embedded grime, algae and oil lifted in seconds.",
    url: "https://customer-assets-39nsmqrw.emergentagent.net/job_e507bcf8-3c78-415b-96df-b7f98a751418/artifacts/553s6ahk_InShot_20260828_140810770.mp4",
  },
  {
    id: "field",
    title: "On-Site Pressure Washing",
    description: "Real work, real results — professional-grade equipment on every job.",
    url: "https://customer-assets-39nsmqrw.emergentagent.net/job_e507bcf8-3c78-415b-96df-b7f98a751418/artifacts/bbz0z378_VID_20260824_195156.mp4",
  },
  {
    id: "detail",
    title: "Detail Surface Cleaning",
    description: "Precision cleaning that protects your surfaces while restoring them.",
    url: "https://customer-assets-39nsmqrw.emergentagent.net/job_e507bcf8-3c78-415b-96df-b7f98a751418/artifacts/h63x6ljn_1787612078739.mp4",
  },
];

export const FLYERS = {
  main: "https://customer-assets-39nsmqrw.emergentagent.net/job_e507bcf8-3c78-415b-96df-b7f98a751418/artifacts/09omgv6h_file_00000000f0cc81f59276d70d2ae63388.png",
  services: "https://customer-assets-39nsmqrw.emergentagent.net/job_e507bcf8-3c78-415b-96df-b7f98a751418/artifacts/5iajc9xc_file_00000000da0c81f5a8ce71dd8f9ed935.png",
};

export const SERVICES = [
  {
    id: "house-washing",
    name: "House Washing",
    tag: "Soft Wash Technology",
    short: "Gentle low-pressure treatment that kills algae, mold, and mildew without damaging delicate siding.",
    idealFor: "Vinyl, Brick, Stucco, Hardie Board, Wood Siding",
    features: ["100% Biodegradable Detergents", "Zero Pressure Siding Damage", "Removes Green Mold & Black Algae", "Extends Paint & Siding Lifespan"],
  },
  {
    id: "driveways",
    name: "Driveway Cleaning",
    tag: "Deep Rotary Scrub",
    short: "High-volume surface cleaning to erase tire marks, oil drips, rust, and ground-in dirt.",
    idealFor: "Concrete, Exposed Aggregate, Pavers, Asphalt",
    features: ["Rotary Flat Surface Cleaner", "Oil Stain Neutralization", "Weed & Moss Removal from Cracks", "Slip Hazard Mitigation"],
  },
  {
    id: "decks-fences",
    name: "Decks & Fences",
    tag: "Wood & Composite Wash",
    short: "Revitalize weathered wood and composite by stripping gray oxidation and organic buildup.",
    idealFor: "Pressure-Treated Pine, Cedar, Composite, Vinyl Fencing",
    features: ["Restores Natural Wood Grain", "Preps Surface for Staining/Sealing", "Safe Low-PSI Rinse", "Removes Black Fungal Rot"],
  },
  {
    id: "sidewalks",
    name: "Sidewalks & Walkways",
    tag: "High-Footfall Wash",
    short: "Brighten entryways and walkways for an immediate pristine curb impression.",
    idealFor: "Front Walkways, Concrete Steps, Garden Paths",
    features: ["Curb Appeal Enhancement", "Gum & Stain Erasure", "Anti-Fungal Barrier Finish", "Fast Dry-Time"],
  },
  {
    id: "patios",
    name: "Patios & Pavers",
    tag: "Sanitize & Seal",
    short: "Deep clean stone and concrete outdoor living areas, restoring color and warmth.",
    idealFor: "Flagstone, Travertine, Stamped Concrete, Brick Pavers",
    features: ["Polishing Surface Finish", "Polymeric Sand Prep", "Eliminates Weed Growth", "Patio Furniture Pre-Wash"],
  },
  {
    id: "commercial",
    name: "Commercial Cleaning",
    tag: "Property Management",
    short: "Scheduled maintenance cleaning for business exteriors, drive-thrus, and walkways.",
    idealFor: "Storefronts, Restaurants, HOAs, Warehouses, Gas Stations",
    features: ["Flexible After-Hours Service", "Hot Water Degreasing", "OSHA Compliant Equipment", "Custom Recurring Contracts"],
  },
];

export const MANIFESTO = [
  {
    number: "01",
    title: "Sanitation & Health First",
    description: "Dirty surfaces aren't just ugly — they harbor black algae, lichen, spores, and bacteria that compromise air quality and create slippery bio-film hazards.",
  },
  {
    number: "02",
    title: "Precision Pressure Dynamics",
    description: "We calibrate exact water volume and pressure paired with eco-formulated surfactants to clean deeply without gouging concrete or stripping paint.",
  },
  {
    number: "03",
    title: "Maximum Curb & Value Restoration",
    description: "Professional pressure washing delivers an immediate boost to property value, preserving exterior materials against long-term deterioration.",
  },
  {
    number: "04",
    title: "Honest Local Craftsmanship",
    description: "Direct communication with the owner. No middleman sales reps, transparent upfront quotes, and 100% satisfaction on every square foot.",
  },
];

export const HEALTH_POINTS = [
  { title: "Removes Mold & Mildew", description: "Spores trigger allergies and breathing problems. We destroy them at the root." },
  { title: "Improves Air Quality", description: "Fewer airborne allergens around your home means easier breathing for your family." },
  { title: "Boosts Curb Appeal", description: "A clean exterior instantly transforms how your property looks and feels." },
  { title: "Protects Your Investment", description: "Grime and decay shorten the life of siding, concrete, and wood. Cleaning prevents it." },
];

export const LOGO = "https://customer-assets-cm19k8pv.emergentagent.net/job_contact-us-web/artifacts/61ac99aeb41e8af5_file_00000000ff4881f6bd3cbf41008eb9ed.png";

export const SPECIALS = [
  { id: "seasonal", label: "Seasonal Plan", washes: 2, perWash: 150, regular: 200, total: 300, highlight: false },
  { id: "best-value", label: "Best Value", washes: 3, perWash: 100, regular: 200, total: 300, highlight: true },
];
